<script>
import { ref, defineComponent, nextTick, watch, computed } from 'vue'
import Splide from '@splidejs/splide'; //https://splidejs.com/
//helper
import Locale from '@/helper/locale/Locale.js';

export default defineComponent({
    props: {
        headList: { type: Array, required: true },
    },
    setup(props,ctx){
        const list = ref(props.headList)
        let activeIndex = ref(0)
        let slider = null

        //#region methods
        const catName = (head) => {
            let localeCode = Locale.getLocaleCode()
            return localeCode == 1033 ? head.header_en : head.header;
        }

        const clickTab = (index) => {
            activeIndex.value = index;
            let send = {
                index: index,
                head: list.value[index]
            }
            ctx.emit('clickTab', send);
        }

        const setSlider = () => {
            nextTick(() => {
                slider = new Splide('#head-slide', {
                    arrows: false,
                    pagination: false,
                    autoWidth: true,
                }).mount()

                slider.on('move', (newIndex) => {
                    activeIndex.value = newIndex
                })
            })
        }
        //#endregion methods

        const classWidth = computed(() => {
            if(list.value.length == 1) {
                return 'w-full'
            }
            return list.value.length > 2 ? 'w-1/3' : 'w-1/2'
        })

        setSlider()

        watch(() => activeIndex.value, (newVal) => {
            clickTab(newVal)
        })

        return {
            list,
            activeIndex,
            catName,
            clickTab,
            classWidth
        }
    }
})
</script>
<template>
    <div v-if="list.length > 0">
        <div class="splide text-14 font-bold" id="head-slide">
            <div class="splide__track">
                <ul class="splide__list">
                    <li class="splide__slide" :class="classWidth"
                        v-for="(head, k) in list"
                        :key="k">
                        <div v-if="k == activeIndex"
                            class="text-center py-2 border-b-4 border-a-red-d62300 text-a-red-d62300"
                            @click="clickTab(k)">
                            {{catName(head)}}
                        </div>
                        <div v-else
                             class="text-center py-2 border-a-brown-d7c7b8 cursor-pointer"
                             @click="clickTab(k)">
                            {{catName(head)}}
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<style lang="scss" scoped>
</style>
